import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const RecentFeed = ({ date, feedback }) => {
  const useStyles = makeStyles((theme) => ({
    container: {
      background: '#E6EDF6',

      marginTop: '10px',
      padding: '10px'
    },
    date: {
      fontSize: '14px',
      fontWeight: 'bold'
    },
    feedback: {
      fontSize: '14px'
    }
  }));

  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h3 className={classes.date}>{date}</h3>
      <p className={classes.feedback}>{feedback}</p>
    </div>
  );
};

export default RecentFeed;
